import { Component, Input } from '@angular/core';

@Component({
	selector: 'cpi-msp-semantix-logo',
	standalone: true,
	imports: [],
	templateUrl: './msp-semantix-logo.component.html',
	styleUrl: './msp-semantix-logo.component.scss',
})
export class MspSemantixLogoComponent {
	@Input() darkMode = false;
}
